import { buildModelManager } from "../builder.js";
const DefaultShopifyOrderLineItemSelection = {
  __typename: true,
  id: true,
  attributedStaffs: true,
  createdAt: true,
  currentQuantity: true,
  discountAllocations: true,
  discountedTotalSet: true,
  discountedUnitPriceAfterAllDiscountsSet: true,
  discountedUnitPriceSet: true,
  fulfillableQuantity: true,
  fulfillmentService: true,
  fulfillmentStatus: true,
  giftCard: true,
  grams: true,
  merchantEditable: true,
  name: true,
  nonFulfillableQuantity: true,
  orderId: true,
  originLocationId: true,
  originalTotalSet: true,
  price: true,
  priceSet: true,
  productExists: true,
  productId: true,
  properties: true,
  quantity: true,
  refundableQuantity: true,
  requiresShipping: true,
  restockable: true,
  shopId: true,
  shopifyCreatedAt: true,
  shopifyUpdatedAt: true,
  sku: true,
  taxLines: true,
  taxable: true,
  title: true,
  totalDiscount: true,
  totalDiscountSet: true,
  unfulfilledDiscountedTotalSet: true,
  unfulfilledOriginalTotalSet: true,
  unfulfilledQuantity: true,
  updatedAt: true,
  variantId: true,
  variantInventoryManagement: true,
  variantTitle: true,
  vendor: true
};
const modelApiIdentifier = "shopifyOrderLineItem";
const pluralModelApiIdentifier = "shopifyOrderLineItems";
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultShopifyOrderLineItemSelection,
    namespace: null
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "shopifyOrderLineItemGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
operations.push(...[
  "create",
  "bulkCreate",
  "update",
  "bulkUpdate",
  "delete",
  "bulkDelete"
].map((operation) => ({
  type: "stubbedAction",
  functionName: operation,
  errorMessage: `The action ${operation} on model shopifyOrderLineItem does not have an api trigger and cannot be called from this api client. If you are the developer of this application and want api clients to call this action add an api trigger to the action. For more information see: https://docs.gadget.dev/guides/actions/triggers`,
  operationName: "",
  dataPath: "",
  actionApiIdentifier: operation,
  modelApiIdentifier,
  variables: {},
  reason: "MissingApiTrigger"
})));
const ShopifyOrderLineItemManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultShopifyOrderLineItemSelection,
  operations
);
export {
  DefaultShopifyOrderLineItemSelection,
  ShopifyOrderLineItemManager
};
//# sourceMappingURL=ShopifyOrderLineItem.js.map
